import './index.scss';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useDocumentsView } from '../provider';
import ClauseElement from './clause_element';
import DecPageElement from './dec_page_element';
const LeftPanel = () => {
    const { decPageFieldKeys, clauseKeys } = useDocumentsView();
    const [panelCollapsed, setPanelCollapsed] = useState(false);
    const panelClass = classnames('left-panel', {
        collapsed: panelCollapsed,
    });
    return (React.createElement("div", { className: panelClass },
        React.createElement("div", { title: `${panelCollapsed ? 'Expand Panel' : 'Collapse Panel'}`, className: 'hide-icon', onClick: () => setPanelCollapsed(!panelCollapsed), "data-public": true },
            panelCollapsed && React.createElement("span", null,
                React.createElement("i", { className: 'fas fa-chevron-right' })),
            !panelCollapsed && React.createElement("span", null,
                React.createElement("i", { className: 'fas fa-chevron-left' }))),
        React.createElement("h4", { "data-public": true }, "PDF Navigation"),
        React.createElement("div", { className: 'data-elements' },
            decPageFieldKeys.map(decPageFieldKey => {
                return React.createElement(DecPageElement, { decPageKey: decPageFieldKey });
            }),
            clauseKeys.map(clauseKey => React.createElement(ClauseElement, { clauseKey: clauseKey })))));
};
export default LeftPanel;
